import React, { Component } from "react";
import { Link } from "react-router-dom";
import parse from "html-react-parser";
import veriler from "./veriler1.json";
import axios, { API_URL } from "../../lib/axios";
import { useState } from "react";
import { useEffect } from "react";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";

const QRPage = (props) => {
  const { id } = useParams();
  const [result, setResult] = useState(null);
  const [isUrl, setIsUrl] = useState(false);
  const[notfound, setNotfound] = useState(false);

  useEffect(() => {
      axios
      .get(API_URL + "/api/qr/url/"+id)
      .then((res) => {
        if(res.status === 200){
          setResult(res.data);
          setIsUrl(true);
        }
        })

        if(isUrl != true)
          {
            axios
            .get(API_URL + "/api/qr/detail/"+id)
            .then((res) => {
              setResult(res.data);
              if(res.status === 200){
                setIsUrl(false);
              }else{
                setNotfound(true);
              }
            }).catch((err) => {
              setNotfound(true);
            });
          }
 
  }, [id]);

  const resultByType = (result) => {
    if(result.active === false) {
      if(localStorage.getItem("lang") != "en")
        {
          return <h1 className="text-center mt-5">QR Kod aktif değil</h1>;

        }
        else
        {
          return <h1 className="text-center mt-5">QR Code is not active</h1>;
        }
    }
    //Link, Image, PDF
    if (result.type === "link") {
      // direct to link
      window.location.href = result.value;
    }
    if (result.type === "image") {
      // show image
      return <img src={API_URL + "/api/image?image=" + result.value + "&path=qr"} alt="QR Code" />;
    }
    if (result.type === "file") {
      // show pdf
      return (
        <div style={{width: "100%", height: "100vh", margin:"0", overflow: "hidden"}}>
        <object 
        style={{width: "100%", height: "100vh"}}
        data={API_URL+"/api/docs?docs=" + result.value + "&path=qr/pdf"}
        type="application/pdf">   </object>
        </div>
      );
    }
  }

  return (
    <div>
      {
        result ? (
          <div>
            {resultByType(result)}
          </div>
        ) : (
          notfound ? (
            localStorage.getItem("lang") != "en" ?
            <h1 className="text-center mt-5">QR Kod bulunamadı</h1> :
            <h1 className="text-center mt-5">QR Code not found</h1>
          ) : (
          localStorage.getItem("lang") != "en" ?
          <h1 className="text-center mt-5">Yükleniyor...</h1> :
          <h1 className="text-center mt-5">Loading...</h1>
          )
        )
        }
    </div>
  );
};

export default QRPage;


